import { Component, Vue } from 'vue-property-decorator';
import { namespace, Action, Getter } from 'vuex-class';
import { COMMON_LOOKUP_TYPE } from '../../../../store/types';
import { storeModules } from '../../../../store';
import moduleConstant from '../../../../common/module-constant';

import { LabelSetting } from './../../../../i18n/locale-helper';
import { ROUTER_HELPER } from '../../../../common/router-helper.contstants';
import { IModuleSearch } from '../../../../models/global-search';
import { OBJECT_TYPE } from '../../../../common/property.constant';
import _ from 'lodash';
import { IAuthConfigModel } from '../../../../models/user/auth-config.model';
const CommonAction = namespace(storeModules.Common, Action);
const UserGetter = namespace(storeModules.User, Getter);
const LookupAction = namespace(storeModules.Lookup, Action);
const TabViewGetter = namespace(storeModules.TabView, Getter);
import EventBus from "../../../../utils/event-bus";
import { EVENT_BUS, LOCALSTORAGE_AUTH2, ROUTER } from "../../../../common/constants";
import { TAB_VIEW_GETTERS } from '../../../../store/tab-view/tab-view-types.store';
import { TabViewModel } from '../../../../models/common/tab-view.model';
import { generateNewTabId } from '../../../../utils/cached-data';
import EventTracker from '../../../../utils/event-tracker';
import { TRACKING_EVENTS } from '../../../../common/tracking-event.constants';
import { IGenericObject } from '../../../../models/common';
import { LOOKUP_TYPE } from '../../../../store/lookup/lookup-properties.store';
import { ApiResponse } from '../../../../models/app-configuration';
// import { DataHelper } from '../../../../utils/data-helper';
// import moment from 'moment';

const LookupGetter = namespace(storeModules.Lookup, Getter);

let handleOutsideClick
Vue.directive('closable', {
    bind(el, binding, vnode) {
        handleOutsideClick = (e) => {
            e.stopPropagation()
            const { handler, exclude } = binding.value
            let clickedOnExcludedEl = false
            exclude.forEach(refName => {
                if (!clickedOnExcludedEl) {
                    const excludedEl = vnode.context.$refs[refName] as any
                    clickedOnExcludedEl = excludedEl.contains(e.target)
                }
            })
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                vnode.context[handler]()
            }
        }
        document.addEventListener('click', handleOutsideClick)
        document.addEventListener('touchstart', handleOutsideClick)
    },

    unbind() {
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('touchstart', handleOutsideClick)
    }
})

@Component({
    template: require("./template.html"),
    components: {
        'new-property-control': () => import('../../../../containers/property/components/new-property-control')
    }
})
class GlobalSearch extends Vue {
    public query: string = '';
    public loading: boolean = false;
    public cardVisible: boolean = false;
    public isShowPropertyModal: boolean = false;
    public listModuleDefault: { Module: number, Items: IModuleSearch[] }[] = [
        { Module: moduleConstant.Object, Items: [] },
        { Module: moduleConstant.Person, Items: [] },
        { Module: moduleConstant.Demand, Items: [] },
        { Module: moduleConstant.Project, Items: [] },
        { Module: moduleConstant.Task, Items: [] },
        { Module: moduleConstant.Agenda, Items: [] },
    ];
    public listOfModuleSearch: IModuleSearch[] = [];
    moduleSuggestion = [];
    @UserGetter authConfig: IAuthConfigModel;

    public isOutWhileTyping: boolean = false;

    get coUserAuthConfig() {
        return this.authConfig;
    }

    //#region LOOKUPS STORE
    @LookupGetter listOfTaskTypes: IGenericObject[];
    get coListOfTaskTypes(){ return this.listOfTaskTypes || []}
    @LookupAction getLookupData: (type: string) => Promise<ApiResponse>;
    //#endregion

    @CommonAction(COMMON_LOOKUP_TYPE.GLOBAL_SEARCH) globalSearch: (payload: { text: string, group?: boolean, module?: number }) => Promise<any>;

    @TabViewGetter(TAB_VIEW_GETTERS.GET_TAB_VIEWS) tabViews: Array<TabViewModel>;


    get getGlobalSearchEnable() {
        let authData = localStorage.getItem(LOCALSTORAGE_AUTH2) as any;
        authData = authData ? JSON.parse(authData) : {} ;
		let customerName = authData?.data?.information?.customerName;
        let isMacnash = false;
        if(customerName && customerName === 'Macnash')
            isMacnash = true;
    
        if (this.coUserAuthConfig && this.coUserAuthConfig.Config.EnableElasticSearch && !isMacnash) {
            return true;
        }
        return false;
    }

    get lblSetting() {
        return LabelSetting.Action;
    }

    get coListOfModule() {
        return this.listOfModuleSearch;
    }

    get coQuery() {
        return this.query;
    }

    set coQuery(value) {
        const vm = this as any;
        this.query = value;
        if (this.query.length > 2) {
            this.cardVisible = true;
        }
        this.handleSearch(value, vm);
    }

    get newSuggestionVisible() {
        return this.moduleSuggestion.length > 0 && !this.loading && this.coQuery;
    }

    get moduleConstant() {
        return moduleConstant
    }

    handleAdvancedSearch() {
        if (this.query.length > 2) {
            const id = generateNewTabId(moduleConstant.AdvanceSearch, this.tabViews);
            const route = {
                params: { id },
                query: this.getQuery({ moduleTypeId: moduleConstant.AdvanceSearch }),
                name: ROUTER.ADVANCE_SEARCH
            }
            this.$router.push(route);
            this.handleHideCard();
        }
    }

    mounted() {
        EventBus.$on(EVENT_BUS.COMMON.LOADED_TRANSALTED, () => {
            this.$forceUpdate()
        });
        window.addEventListener('resize', this.resizeHandle, false);
        this.getLookupData(LOOKUP_TYPE.TaskType);
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandle, false);
    }

    resizeHandle() {
        if (this.cardVisible && (this as any).$refs.boxSearch.$el) {
            this.calculateWidthBoxSearch();
        }
    }

    checkShowPreview(item: IModuleSearch) {
        if (item.Module == moduleConstant.Agenda || item.Module == moduleConstant.Task) {
            return false;
        }
        return true;
    }

    handleSearch = _.debounce(async (query, vm) => {
        if (query.length > 2) {
            vm.loading = true;
            const response = await vm.globalSearch({ text: query, group: false, module: vm.$route.meta.module ? vm.$route.meta.module : moduleConstant.Agenda });
            console.log('search result: ', response);
            if (response) {
                vm.listOfModuleSearch = response.Datas;
                vm.moduleSuggestion = response.ModuleTypes || []
            }
            vm.loading = false;
        } else {
            vm.listOfModuleSearch = [];
            vm.moduleSuggestion = [];
        }
    }, 500);

    handleShowCard() {
        this.cardVisible = true;
        this.query = '';
        this.listOfModuleSearch = [];
        this.$nextTick(() => {
            const vm = this as any;
            if (vm.$refs.boxSearch.$el.offsetWidth <= 500) {
                vm.calculateWidthBoxSearch();
            }
            vm.$refs.inputGlobalSearch.focus();
        });
    }

    calculateWidthBoxSearch() {
        const bodyRect = window.document.body.getBoundingClientRect();
        const boxRect = (this as any).$refs.boxSearch.$el.getBoundingClientRect();
        const width = bodyRect.width - boxRect.x - 10;
        (this as any).$refs.boxSearch.$el.style.width = `${width}px`;
    }

    handleClickOutCard () {
        this.handleHideCard (true);
    }

    handleHideCard( temporary?: boolean) {
        if (this.isShowPropertyModal) return;
        
        temporary = temporary || false;
        if (temporary === true && this.coQuery != "") {
            this.isOutWhileTyping = true;
        } else {
            this.isOutWhileTyping = false;
            this.cardVisible = false;
            (this as any).$refs.boxSearch.$el.style.width = "";
            (this as any).$refs.inputGlobalSearch.$el.blur();
        }
    }

    handleClickTitle(item: IModuleSearch) {
        switch (item.Module) {
            case moduleConstant.Agenda:
            case moduleConstant.Task:
                return this.handleEdit(item);
            default:
                return this.handleView(item);
        }
    }

    /** 
     * Description: Get Icon Module
     * Author: hungnm@omnicasa.com
     * @param id
    */
    getIconModule(id) {
        switch (id) {
            case moduleConstant.Object:
                return 'ico_home';
            case moduleConstant.Project:
                return 'ico_project';
            case moduleConstant.Person:
                return 'ico_person';
            case moduleConstant.Demand:
                return 'ico_demand';
            case moduleConstant.Agenda:
                return 'ico_calendar';
            case moduleConstant.Task:
                return 'ico_task';
            default:
                return '';
        }
    }

    /** 
     * Description: Get search title
     * Author: trungdq@omnicasa.com
     * @param id
    */
    getSearchTitle(id) {
        switch (id) {
            case moduleConstant.Object:
                return this.$t('SEARCH_FOR_PROPERTIES');
            case moduleConstant.Project:
                return this.$t('SEARCH_FOR_PROJECT');
            case moduleConstant.Person:
                return this.$t('SEARCH_FOR_PERSON');
            case moduleConstant.Demand:
                return this.$t('SEARCH_FOR_DEMAND');
            case moduleConstant.Agenda:
                return this.$t('SEARCH_FOR_AGENDA');
            case moduleConstant.Task:
                return this.$t('SEARCH_FOR_TASK');
            default:
                return '';
        }
    }

    optimizeDisplayInfo(item: IModuleSearch) {
        let displayName = ``;
        if(item.Reference) displayName = `${ item.Reference }`;

        switch(item.Module) {
            case moduleConstant.Person:
                if (item.Source.CompanyName)
                    displayName += `, ${item.Source.CompanyName}`;
                if (item.Source.CityName)
                    displayName += `, ${item.Source.CityName}`;
                if (item.Source.Emails)
                    displayName += `, ${item.Source.Emails}`;
                if (item.Source.PhoneNumbers)
                    displayName += ` ${item.Source.PhoneNumbers}`;
                displayName = displayName.replace('  ', ' ').replace(' ,', ',');
                break;
            case moduleConstant.Agenda:
                const vm = this as any;
                var startDate = vm.$formatAppoimentDate(item.Source.StartTime);
                if (item.Source.Subject)
                    displayName = `${item.Source.Subject}`;
                if (startDate)
                    displayName += `, ${startDate}`;
                if (item.UserNames)
                    displayName += `, ${item.UserNames.join(',')}`;
                break;
            case moduleConstant.Task:
                const vmTask = this as any;
                const taskDate = vmTask.$formatDateTimeByLocale(item.Source.Date);
                if (item.Source.Subject)
                    displayName = `${item.Source.Subject}`;
                if(item.Source.TypeId && this.listOfTaskTypes.length > 0) {
                    const task = this.listOfTaskTypes.find(x => x.Id === item.Source.TypeId)
                    displayName += ` - ${vmTask.$td(task)}`;
                }
                if (taskDate)
                    displayName += ` - ${taskDate}`;
                break;
            default:
                break;
        }

        if(displayName.trim().length === 0)
            displayName += `&nbsp;`;

        var info = { text: displayName, showTooltip: false, tooltip: null };

        // if (info.text) {
        //     if (info.text.length > 80) {
        //         info.showTooltip = true;
        //         info.tooltip = info.text;
        //         info.text = `${info.text.slice(0, 3000)}...`;
        //     }

        //     // info.text = `${mark(info.text, this.query.trim())}`;
        // }

        item['displayInfo'] = info;
    }

    clearDisplayInfo(item: IModuleSearch) {
        if (item['displayInfo']) {
            delete item['displayInfo'];
        }
    }

    /** 
     * Description: handle open view.
     * Author: hungnm@omnicasa.com
     * @param id number
    */
    handleView(moduleItem: IModuleSearch) {
        let payload = {};
        switch (moduleItem.Module) {
            case moduleConstant.Object:
                payload = { name: ROUTER.PROPERTY.PROPERTY_VIEW, params: { id: moduleItem.Id } }
                break;
            case moduleConstant.Project:
                payload = { name: ROUTER.PROPERTY.PROPERTY_PROJECT_VIEW, params: { id: moduleItem.Id } }
                break;
            case moduleConstant.Person:
                payload = { name: ROUTER.CLIENT.CLIENT_VIEW, params: { id: moduleItem.Id } }
                break;
            case moduleConstant.Demand:
                payload = { name: ROUTER.DEMAND.DEMAND_DETAIL, params: { id: moduleItem.Id } }
                break;
            case moduleConstant.Agenda:
                payload = { name: ROUTER.AGENDA.AGENDA_VIEW, params: { id: moduleItem.Id } }
                break;
            case moduleConstant.Task:
                payload = { name: ROUTER.TASK.TASK_VIEW, params: { id: moduleItem.Id } }
                break;
            default:
                break;
        }
        this.$router.push(payload);
        this.handleHideCard();
        EventTracker.logEvent({
            FormName: TRACKING_EVENTS.PAGES.GLOBAL,
            Action: TRACKING_EVENTS.EVENTS.GLOBAL_SEARCH_VIEW_RESULT,
            FormId: payload['params'].id,
            Comment: payload
        })
    }

    /** 
     * Description: handle open view.
     * Author: hungnm@omnicasa.com
     * @param id number
    */
    handleEdit(moduleItem: IModuleSearch) {
        console.log('moduleItemSearchGlobal: ', moduleItem)
        let payload = {};
        switch (moduleItem.Module) {
            case moduleConstant.Object:
                payload = { name: ROUTER.PROPERTY.PROPERTY_EDIT, params: { id: moduleItem.Id }}
                break;
            case moduleConstant.Project:
                payload = { name: ROUTER.PROJECT.PROJECT_EDIT, params: { id: moduleItem.Id } }
                break;
            case moduleConstant.Person:
                payload = { name: ROUTER.CLIENT.CLIENT_EDIT, params: { id: moduleItem.Id } }
                break;
            case moduleConstant.Demand:
                payload = { name: ROUTER.DEMAND.DEMAND_EDIT, params: { id: moduleItem.Id } }
                break;
            case moduleConstant.Agenda:
                const routeName = moduleItem.IsRecurrence && !moduleItem.IsException ? ROUTER.AGENDA.AGENDA_EDIT_SERIES : ROUTER.AGENDA.AGENDA_EDIT
                payload = { name: routeName, params: { id: moduleItem.Id } }
                break;
            case moduleConstant.Task:
                payload = { name: ROUTER.TASK.TASK_EDIT, params: { id: moduleItem.Id } }
                break;
            default:
                break;
        }
        this.$router.push(payload);
        this.handleHideCard();
        EventTracker.logEvent({
            FormName: TRACKING_EVENTS.PAGES.GLOBAL,
            Action: TRACKING_EVENTS.EVENTS.GLOBAL_SEARCH_EDIT_RESULT,
            FormId: payload['params'].id,
            Comment: payload
        })
    }



    /** 
     * Description: handle open view.
     * Author: hungnm@omnicasa.com
     * @param id number
    */
    handleCreate(moduleTypeId: number) {
        const id = generateNewTabId(moduleTypeId, this.tabViews);
        let payload = {};
        switch (moduleTypeId) {
            case moduleConstant.Object:
                payload = { name: ROUTER.PROPERTY.PROPERTY_NEW }
                break;
            case moduleConstant.Project:
                payload = { name: ROUTER.PROJECT.PROJECT_NEW }
                break;
            case moduleConstant.Person:
                payload = { name: ROUTER.CLIENT.CLIENT_NEW }
                break;
            case moduleConstant.Demand:
                payload = { name: ROUTER.DEMAND.DEMAND_NEW }
                break;
            case moduleConstant.Agenda:
                payload = { name: ROUTER.AGENDA.AGENDA_NEW }
                break;
            case moduleConstant.Task:
                payload = { name: ROUTER.TASK.TASK_NEW }
                break;
            default:
                break;
        }
        const route = {
            params: { id },
            query: this.getQuery({ moduleTypeId }),
            ...payload
        }
        this.$router.push(route);
        this.handleHideCard();
        EventTracker.logEvent({
            FormName: TRACKING_EVENTS.PAGES.GLOBAL,
            Action: TRACKING_EVENTS.EVENTS.GLOBAL_SEARCH_NEW_OBJECT,
            FormId: 0,
            Comment: route
        })
    }

    getNewModuleText(module: number) {
        switch (module) {
            case moduleConstant.Agenda:
                return this.$t('CREATE_NEW_APPOINTMENT');
            case moduleConstant.Object:
                return this.$t('CREATE_NEW_PROPERTY');
            case moduleConstant.Task:
                return this.$t('CREATE_NEW_TASK');
            case moduleConstant.Person:
                return this.$t('CREATE_NEW_PERSON');
        }
    }

    getTypeByModule(payload: { moduleId: number, ConstructionType?: number, action?: string }) {
        switch (payload.moduleId) {
            case moduleConstant.Object:
                if (payload.action && payload.action == ROUTER_HELPER.ACTION.NEW) {
                    return ROUTER_HELPER.TYPE.PREPARE_PROPERTY;
                } else {
                    return ROUTER_HELPER.TYPE.PROPERTY;
                }
            case moduleConstant.Project:
                if (payload.action && payload.action == ROUTER_HELPER.ACTION.NEW) {
                    return ROUTER_HELPER.TYPE.PREPARE_PROPERTY;
                } else {
                    return ROUTER_HELPER.TYPE.PROJECT;
                }
            case moduleConstant.Person:
                return ROUTER_HELPER.TYPE.CLIENT;
            case moduleConstant.Demand:
                return ROUTER_HELPER.TYPE.DEMAND;
            case moduleConstant.Agenda:
                return ROUTER_HELPER.TYPE.AGENDA;
            case moduleConstant.Task:
                return ROUTER_HELPER.TYPE.TASK;
            default:
                return '';
        }
    }

    private getQuery(payload: { moduleTypeId: number, [key: string]: any }) {
        switch (payload.moduleTypeId) {
            case moduleConstant.Object:
                return {
                    type: payload.ConstructionType ? payload.ConstructionType : OBJECT_TYPE.PROPERTY,
                    searchText: this.query,
                }
            case moduleConstant.Project:
                return {
                    type: OBJECT_TYPE.PROJECT,
                    searchText: this.query,
                }
            default:
                return {
                    searchText: this.query
                };
        }
    }

    getParams(moduleItem: IModuleSearch) {
        switch (moduleItem.Module) {
            case moduleConstant.Object:
                return {
                    propertyId: moduleItem.Id,
                };
            case moduleConstant.Project:
                return {
                    projectId: moduleItem.Id,
                };
            case moduleConstant.Person:
                return {
                    clientId: moduleItem.Id,
                };
            case moduleConstant.Demand:
                return {
                    demandId: moduleItem.Id,
                };
            case moduleConstant.Agenda:
                return {
                    agendaId: moduleItem.Id,
                    masterId: moduleItem.MasterId,
                };
            case moduleConstant.Task:
                return {
                    taskId: moduleItem.Id,
                };
            default:
                return {};
        }
    }
    onCloseInitProperty() {
        this.isShowPropertyModal = false
        this.handleHideCard()
        EventTracker.logEvent({
            FormName: TRACKING_EVENTS.PAGES.GLOBAL,
            Action: TRACKING_EVENTS.EVENTS.GLOBAL_SEARCH_NEW_OBJECT,
            FormId: 0,
            Comment: {
                name: 'newProperty', 
                query: {
                    searchText: this.coQuery
                }
            }
        })
    }
}

export default GlobalSearch;
